import loadScript from "./load-script"

const cdn = "//cdnjs.cloudflare.com/ajax/libs/highlight.js"
let loaded = false
//formerly color: #c0c5ce
const darkStyles = `
  .hljs{display:block;color:#C792EA;padding:15px;border-radius:3px}
  .hljs-comment,.hljs-quote{color:#65737e}.hljs-variable,.hljs-template-variable,.hljs-tag,.hljs-name,.hljs-selector-id,.hljs-selector-class,.hljs-regexp,.hljs-deletion,.hljs-subst{color:#bf616a}.hljs-number,.hljs-built_in,.hljs-builtin-name,.hljs-literal,.hljs-type,.hljs-params,.hljs-meta,.hljs-link{color:#d08770}.hljs-attribute{color:#ebcb8b}.hljs-string,.hljs-symbol,.hljs-bullet,.hljs-addition{color:#a3be8c}.hljs-title,.hljs-section{color:#8fa1b3}.hljs-keyword,.hljs-selector-tag{color:#b48ead}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:bold}
`

const lightStyles = `
  .hljs{display:block;overflow-x:auto;padding:.5em;color:#383a42;background:#fafafa}.hljs-comment,.hljs-quote{color:#a0a1a7;font-style:italic}.hljs-doctag,.hljs-formula,.hljs-keyword{color:#a626a4}.hljs-deletion,.hljs-name,.hljs-section,.hljs-selector-tag,.hljs-subst{color:#e45649}.hljs-literal{color:#0184bb}.hljs-addition,.hljs-attribute,.hljs-meta-string,.hljs-regexp,.hljs-string{color:#50a14f}.hljs-built_in,.hljs-class .hljs-title{color:#c18401}.hljs-attr,.hljs-number,.hljs-selector-attr,.hljs-selector-class,.hljs-selector-pseudo,.hljs-template-variable,.hljs-type,.hljs-variable{color:#986801}.hljs-bullet,.hljs-link,.hljs-meta,.hljs-selector-id,.hljs-symbol,.hljs-title{color:#4078f2}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:700}.hljs-link{text-decoration:underline}
`

export function highlight(el, cb = () => {}, styles = darkStyles) {
  const snippets = el
    ? [el]
    : [].slice.call(document.querySelectorAll("pre code"))

  if (snippets.length === 0) return

  loadScript({
    src: `${cdn}/9.15.8/highlight.min.js`,
    onload() {
      snippets.forEach(snip => {
        const arr = snip.className.split(" ")
        const lang = arr.find(c => c.indexOf("language-") !== -1)

        if (!lang) {
          window.hljs.highlightBlock(snip)
          cb()
          return
        }

        const str = lang.split("-").pop()
        const foundlang = window.hljs.getLanguage(str)

        if (!foundlang) {
          loadScript({
            src: `${cdn}/9.15.8/languages/${str}.min.js`,
            onload() {
              window.hljs.highlightBlock(snip)
              cb()
            },
          })
        } else {
          window.hljs.highlightBlock(snip)
          cb()
        }
      })
    },
  })

  if (!loaded) {
    loaded = true
    loadScript({
      style: true,
      innerHTML: styles,
    })
  }
}

export function highlightDark(el, cb = () => {}) {
  highlight(el, cb, darkStyles)
}

export function highlightLight(el, cb = () => {}) {
  highlight(el, cb, lightStyles)
}
